export const AUTH_QUERY_PARAM_FOR_PREFILL_EMAIL = 'prefillEmail';
/**
 * for cases when user signed up after generating QR code on WP widget or when claiming QR code
 */
export const AUTH_QUERY_PARAM_AUTO_LINK_QR_ID = 'autoLinkQRID';
